import React from "react";
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  useTheme,
} from "@mui/material";
import { LocationOn } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const ProjectGallery = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const projects = t("projects.projectsList", { returnObjects: true });
  const direction = i18n.dir(); // 'ltr' or 'rtl'

  return (
    <Box
      sx={{
        p: 4,
        background: "lightgray",
        minHeight: "100vh",
        borderBottomRadius:"20px",
        direction, // set direction dynamically
      }}
    >
      <Typography
        variant="h4"
        align="center"
        fontWeight="bold"
        gutterBottom
        sx={{ mb: 4, color: "dodgerblue" }}
      >
        {t("projects.title")}
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {projects.map((project, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                borderRadius: 5,
                overflow: "hidden",
                transition: "transform 0.5s ease, box-shadow 0.5s ease",
                boxShadow:
                  "0 12px 20px rgba(0, 0, 0, 0.1), inset 0 0 0 rgba(0,0,0,0)",
                "&:hover": {
                  transform: "scale(1.05) rotate3d(1, 1, 0, 5deg)",
                  boxShadow:
                    "0 20px 40px rgba(0, 0, 0, 0.3), inset 0 0 30px rgba(0,0,0,0.1)",
                },
              }}
            >
              <Box
                sx={{
                  overflow: "hidden",
                  height: 200,
                  position: "relative",
                }}
              >
                <CardMedia
                  component="img"
                  image={project.image || `images/img${index + 1}.jpg`}
                  alt={project.name}
                  sx={{
                    height: "100%",
                    width: "100%",
                    objectFit: "cover",
                    transition: "transform 0.5s ease",
                    "&:hover": {
                      transform: "scale(1.1)",
                    },
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background:
                      "linear-gradient(to bottom, rgba(0,0,0,0.0), rgba(0,0,0,0.6))",
                  }}
                />
              </Box>
              <CardContent sx={{ backgroundColor: "#fff" }}>
                <Typography variant="h6" fontWeight="bold" gutterBottom style={{color:"dodgerblue"}}>
                  {project.name}
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                  {project.description}
                </Typography>
                {project.area && (
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    {t("projects.area")}: {project.area}
                  </Typography>
                )}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: 1,
                    flexDirection: direction === "rtl" ? "row-reverse" : "row",
                  }}
                >
                  <LocationOn
                    fontSize="small"
                    sx={{
                      mx: 0.5,
                      color: theme.palette.primary.main,
                      transform: direction === "rtl" ? "scaleX(-1)" : "none",
                    }}
                  />
                  <Typography variant="body2" color="text.secondary">
                    {t("projects.location")}: {project.location}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ProjectGallery;
